import { useEffect } from 'react';

import { pageTitle } from '../lib/title.js';

/**
 * The tab is shared between every party a phone has open, so the party name
 * leads and the app name follows.
 */
export const usePageTitle = (partyName: string | undefined): void => {
  useEffect(() => {
    document.title = pageTitle(partyName);

    return (): void => {
      document.title = pageTitle(undefined);
    };
  }, [partyName]);
};
